import angular from "angular";
import { SubFilter } from "./subFilters";


export class NumberFilter extends SubFilter {
  getGui(): angular.IAugmentedJQuery {
    return angular.element(`<input type="number" ng-model="${this.getQueryFieldExpression()}" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" />`);
  }
}